export default function brand_details()
{
    return({
        //Company Information
        name: "AI Campus",
        subtitle: "Data Intelligence",
        sub_entity_name: "Property Portfolio",
        sub_entity_subtitle: "Portfolio Overview",
        
        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-short-logo")
        .replace(/['"]+/g, "")
    });
}
